import { TileIndex } from "../../types";

export const WATER_LEVEL: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 16, 16, 16, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 12, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 19, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 16, 16, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 18, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 16, 16, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 18, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 18, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 2, 2, 0, 15, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 16, 16, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 16, 16, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 16, 16, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]